@if (authService.loggedIn && !publicMode) {
  <header class="app-header">
    <div class="header-left">
      <div class="menu-small-screen">
        <img src="assets/brand/favicon.webp" alt="Logo" class="mobile-header-logo" />


        <mat-menu #mobileMenu="matMenu" class="mobile-menu-panel" backdropClass="mobile-menu-backdrop">
          <div class="mobile-menu-header" (click)="$event.stopPropagation()">
            <img class="ff-logo mobile-menu-header-logo" src="assets/images/svg/fagforbundet-logo-rgb.webp" alt="Logo" />
            <button
              type="button"
              mat-icon-button
              class="mobile-menu-close"
              aria-label="Lukk meny"
              (click)="$event.stopPropagation(); mobileMenuTrigger?.closeMenu()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
          @if (mobileMenuLevel === 'root') {
            <button mat-menu-item class="mobile-menu-item-root" (click)="navigateMobileItem(mobileMenuHomeItem, $event)">
              <mat-icon>home</mat-icon>
              <span>Forside</span>
            </button>

            @for (category of mobileMenuCategories; track category.id) {
              <button mat-menu-item class="mobile-menu-item-root" (click)="openMobileCategory(category.id, $event)">
                <span>{{ category.text }}</span>
                <mat-icon class="mobile-menu-item-chevron">chevron_right</mat-icon>
              </button>
            }
          } @else if (activeMobileCategory) {
            <button mat-menu-item class="mobile-menu-item-back" (click)="backToMobileRoot($event)">
              <mat-icon class="mobile-menu-item-chevron">chevron_left</mat-icon>
              <span>Tilbake</span>
            </button>

            @for (item of activeMobileCategory.items; track item.text) {
              <button mat-menu-item (click)="navigateMobileItem(item, $event)">
                @if (item.icon) {
                  <mat-icon>{{ item.icon }}</mat-icon>
                } @else if (item.cssClass) {
                  <span class="custom-icon" [ngClass]="item.cssClass"></span>
                }
                <span>{{ item.text }}</span>
              </button>
            }
          }

          <button class="mobile-menu-section-start mobile-menu-item-utility" mat-menu-item (click)="navigateMobileItem({ text: 'Min Profil', link: '/min-profil', icon: 'person' }, $event)">
            <mat-icon>person</mat-icon>
            <span>Min Profil</span>
          </button>

          <button class="mobile-menu-item-utility" mat-menu-item (click)="navigateMobileItem({ text: 'Kontakt oss', link: '/kontakt-oss', icon: 'chat' }, $event)">
            <mat-icon>chat</mat-icon>
            <span>Kontakt oss</span>
          </button>

          <button class="mobile-menu-item-utility" mat-menu-item (click)="navigateMobileItem({ text: 'Håndter cookies', link: '/cookies', icon: 'cookie' }, $event)">
            <mat-icon>cookie</mat-icon>
            <span>Håndter cookies</span>
          </button>

          <button mat-menu-item class="mobile-menu-item--logout" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logg ut</span>
          </button>

        </mat-menu>
      </div>

      <button type="button" mat-icon-button class="home-item" aria-label="Gå til forsiden" (click)="goHome()">
        <mat-icon>home</mat-icon>
      </button>


      @for (crumb of breadcrumbs; track $index) {
        <mat-icon class="breadcrumb-icon">chevron_right</mat-icon>
        <ng-container>
          @if (crumb === 'Utmelding' && breadcrumbs.length > 1) {
            <a class="path-info" [href]="'/utmelding'">{{ crumb }}</a>
          } @else if (crumb === 'Stipend' && breadcrumbs.length > 1) {
            <a class="path-info" [href]="'/stipend'">{{ crumb }}</a>
          } @else {
            <span class="path-info">{{ crumb }}</span>
          }
        </ng-container>
      }
    </div>

    <div class="header-right">
      <button
        type="button"
        mat-icon-button
        class="mobile-menu-trigger mobile-menu-trigger--header-right"
        [matMenuTriggerFor]="mobileMenu"
        #mobileMenuTrigger="matMenuTrigger"
        (menuOpened)="resetMobileMenu()"
        aria-label="Åpne meny"
      >
        <mat-icon>menu</mat-icon>
      </button>

      <button
        type="button"
        mat-icon-button
        class="theme-toggle-btn"
        [attr.aria-label]="isDarkTheme ? 'Bytt til lysmodus' : 'Bytt til mørkmodus'"
        [title]="isDarkTheme ? 'Lysmodus' : 'Mørkmodus'"
        (click)="toggleTheme()"
      >
        <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>


      <button
        type="button"
        mat-icon-button
        [matMenuTriggerFor]="beforeMenu"
        [disabled]="isMemberInfoLoading"
        title="Åpne profil meny"
        class="avatar-btn"
        [class.avatar-btn-loading]="isMemberInfoLoading"
        [attr.aria-busy]="isMemberInfoLoading"
      >
        @if (isMemberInfoLoading) {
          <span class="avatar-loading-dot" aria-hidden="true"></span>
        } @else if (showAvatarFallbackIcon) {
          <mat-icon class="avatar-fallback-icon">person</mat-icon>
        } @else {
          {{ memberInitials }}
        }
      </button>

      <mat-menu #beforeMenu="matMenu" class="ff-menu" #menu="matMenu" xPosition="before">
        <div class="profile">
          <div class="initials-circle">
            @if (isMemberInfoLoading) {
              <span class="avatar-loading-dot" aria-hidden="true"></span>
            } @else if (showAvatarFallbackIcon) {
              <mat-icon class="avatar-fallback-icon">person</mat-icon>
            } @else {
              {{ memberInitials }}
            }
          </div>
          <div class="profile-info">
            <div class="name">{{ memberInfo?.fullName }}</div>
            <div class="email">{{ memberInfo?.emailAddress }}</div>
          </div>
        </div>
        <hr stop-propagation />
        <a class="ff-menu-item flex items-center gap-3" routerLink="/min-profil">
          <mat-icon class="material-icons-outlined">person</mat-icon>
          <div>Din profil</div>
        </a>
        <hr stop-propagation />
        <button type="button" class="ff-menu-item flex items-center gap-3 no-border-button" routerLink="/cookies">
          <mat-icon class="material-icons-outlined">cookie</mat-icon>
          <div>Håndter cookies</div>
        </button>

        <button type="button" class="ff-menu-item flex items-center gap-3 no-border-button" (click)="logout()">
          <mat-icon>logout</mat-icon>
          <div>Logg out</div>
        </button>
      </mat-menu>
    </div>
  </header>
} @else {
  <header class="app-mini-header">
    <div class="header-left">
      <div class="header-left">
        <img class="ff-logo" src="assets/images/svg/fagforbundet-logo-rgb.webp" alt="Logo" />
      </div>
    </div>
    <div class="app-mini-header-right">
      <button
        type="button"
        mat-icon-button
        class="theme-toggle-btn"
        [attr.aria-label]="isDarkTheme ? 'Bytt til lysmodus' : 'Bytt til mørkmodus'"
        [title]="isDarkTheme ? 'Lysmodus' : 'Mørkmodus'"
        (click)="toggleTheme()"
      >
        <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>
    </div>
  </header>
}
